'use client'
import { createContext, useContext } from "react";
const TableRowContext = /*#__PURE__*/ createContext({});
const useTableRowContext = ()=>useContext(TableRowContext);
export { TableRowContext, useTableRowContext };
